// API 模块统一导出（桶文件）
// 此文件整合所有模块导出，实现向后兼容

import login from "./login";
import job from "./job";
import company from "./company";
import talent from "./talent";
import team from "./team";
import interview from "./interview";
import image from "./image";
import resume from "./resume";
import channel from "./channel";
import broker from "./broker";
import region from "./region";
import project from "./project";
import audit from "./audit";
import account from "./account";
import statistics from "./statistics";

export default {
  ...login,
  ...job,
  ...company,
  ...talent,
  ...team,
  ...interview,
  ...image,
  ...resume,
  ...channel,
  ...broker,
  ...region,
  ...project,
  ...audit,
  ...account,
  ...statistics
};
